"use strict";

/**
 * PersonAlias is what we expose as a Person to the outside word. Its called an alias, because all real data is private
 * to the People class.
 *
 * @param people
 * @param personKey
 * @constructor
 */
var PersonAlias = function (people, personKey) {
    var This = this;
    This._people = people;
    This._personKey = personKey;
};

PersonAlias.prototype.getPeople = function () {
    var This = this;
    return This._people;
};

PersonAlias.prototype.getPersonKey = function () {
    var This = this;
    return This._personKey;
};

PersonAlias.prototype.serialize = function (serializationQuery) {
    let This = this;
    return Object.assign({}, {personId: This._personKey }, serializationQuery.reduce((prev, curr) => {
        if (typeof This[curr] !== 'undefined') {
            return Object.assign(prev, { [curr.toString()]: This[curr] });
        } else {
            return Object.assign(prev, { [curr.toString()]: This.getDetail(curr) });
        }   
    }, {}))
};

const checkNameStatus = (params) => {
    if (params['firstName'] && params['lastName']) {
        params['name'] = `${params['firstName']} ${params['lastName']}`;
        delete params['firstName'];
        delete params['lastName']
        return params;
    } else {
        return params;
    }
}

PersonAlias.prototype.update = function (parameters) {
    let This = this;
    return Promise.all(
        Object.keys(checkNameStatus(parameters)).map(key => {
            if (key !== 'inviteeId' && key !== 'eventId') {
                if (props[key]) {
                    return This._update(props[key].set, key, parameters[key])
                } else {
                    return This._update('setDetail', key, parameters[key])
                }
            }
        })
    )
};

PersonAlias.prototype._update = function(func, key, val) {
    let This = this;
    return new Promise((resolve, reject) => {
        if (func === 'setName') {
            let first = val.split(' ')[0];
            let last = val.split(' ')[1];
            if (!first || !last) {
                reject({error: 'name needs to values seperated by a space'});
            }
            This[func](first, last, () => resolve({[key]: val}));
        } else if (func === 'setDetail') {
            This[func](key, val, () => resolve({[key]: val}))
        } else {
            This[func](val, () => resolve({[key]: val}));
        }
    });
};



var __addPersonAliasFunction = function (personFunc, peopleFunc) {
    PersonAlias.prototype[personFunc] = function () {
        var This = this;
        return This._people[peopleFunc].bind(This._people, This._personKey).apply(null, arguments);
    };
};

var __addPersonAliasProperty = function (personProperty, peopleFunc) {
    Object.defineProperty(PersonAlias.prototype, personProperty, {
        enumerable: true,
        get: function () {
            var This = this;
            var personKey = This._personKey;
            var people = This._people;
            return people[peopleFunc].apply(people, [personKey]);
        }
    });
};

const props = {
    // props
    name: {get: "getName", set: "setName", prop: true, func: true},
    email: {get: "getEmail", set: "setEmail", prop: true, func: true},
    emailVerified: {get: "getEmailVerified", set: null, prop: true, func: true},
    badEmail: {get: "getBadEmail", set: "setBadEmail", prop: true, func: true},
    firstName: {get: "getFirstName", set: "setFirstName", prop: true, func: true},
    lastName: {get: "getLastName", set: "setLastName", prop: true, func: true},
    wasEvicted: {get: "getWasEvicted", set: null, prop: true, func: true},
    hasLeft: {get: "getHasLeft", set: null, prop: true, func: true},
    avatar: {get: "getAvatar", set: "setAvatar", prop: true, func: true},
    inviteeKeys: {get: "getInviteeKeys", set: null, prop: true, func: true}, 
    userProfileKeys: {get: "getUserProfileKeys", set: null, prop: true, func: true},
    globalProfileKeys: {get: "getGlobalProfileKeys", set: null, prop: true, func: true},
    status: {get: "getStatus", set: "setStatus", prop: true, func: true},
    lastTimestamp: {get: "getLastTimestamp", set: null, prop: true, func: true},
    createdAt: {get: "getCreatedAt", set: null, prop: true, func: true},
    createdBy: {get: "getCreatedBy", set: null, prop: true, func: true},
    nameTimestamp: {get: "getNameTimestamp", set: null, prop: true, func: true},
    isHeadOfHousehold: {get: "getIsHeadOfHousehold", set: "setIsHeadOfHousehold", prop: true, func: true},
    householdId: {get: 'getHouseholdId', set: 'setHouseholdId', prop: true, func: true},
    isVisibleToGuestInGuestList: {get: 'getIsVisibleToGuestInGuestList', set: null, prop: true, func: true},
    // methods only
    detail: {get: 'getDetail', set: 'setDetail', prop: false, func: true},
    assimilate: {get: null, set: 'assimilate', prop: false, func: true},
    detailTimestamp: {get: 'getDetailTimestamp', set: null, prop: false, func: true},
    answer: {get: 'getAnswer', set: 'setAnswer', prop: false, func: true },
    answerJSON: {get: 'getAnswerJSON', set: null, prop: false, func: true },
    answerTimestamp: {get: 'getAnswerTimestamp', set: null, prop: false, func: true},
    tags: { get: 'getTags', set: null, prop: false, func: true},
    household: {get:'getHousehold', set: 'setHousehold', prop: false, func: true },
    ensureInviteeOrWritable: {get: 'ensureInviteeOrWritable', set: null, prop: false, func: true}
};

Object.keys(props).forEach(prop => {
    if (props[prop].prop) {
        __addPersonAliasProperty.apply(null, [prop.toString(), `_${props[prop].get}`])
    }
    if (props[prop].func) {
        //getter
        if (props[prop].get) {
            __addPersonAliasFunction.apply(null, [props[prop].get, `_${props[prop].get}`]);
        }
        //setter
        if (props[prop].set) {
            __addPersonAliasFunction.apply(null, [props[prop].set, `_${props[prop].set}`]);
        }
    }
});

export default PersonAlias;

// Leaving these down here for posterity (incase I missed something and it blows up check to make sure props contains all functions bellow)

//Functions
// [
//     ["getFirstName", "_getFirstName"],
//     ["getLastName", "_getLastName"],
//     ["getName", "_getName"],
//     ["getEmail", "_getEmail"],
//     ["setEmail", "_setEmail"],
//     ["getBadEmail", "_getBadEmail"],
//     ["setBadEmail", "_setBadEmail"],
//     ["setFirstName", "_setFirstName"],
//     ["setLastName", "_setLastName"],
//     ["setName", "_setName"],
//     ["assimilate", "_assimilate"],
//     ["getDetail", "_getDetail"],
//     ["getDetailTimestamp", "_getDetailTimestamp"],
//     ["setDetail", "_setDetail"],
//     ["getAnswer", "_getAnswer"],
//     ["getAnswerTimestamp", "_getAnswerTimestamp"],
//     ["setAnswer", "_setAnswer"],
//     ["getTags", "_getTags"],
//     ["getHouseholdId", "_getHouseholdId"],
//     ["setHouseholdId", "_setHouseholdId"],
//     ["getIsHeadOfHousehold", "_getIsHeadOfHousehold"],
//     ["setIsHeadOfHousehold", "_setIsHeadOfHousehold"],
//     ["getHousehold", "_getHousehold"],
//     ["setHousehold", "_setHousehold"],
//     ["getWasEvicted", "_getWasEvicted"],
//     ["getHasLeft", "_getHasLeft"],
//     ["getAvatar", "_getAvatar"],
//     ["setAvatar", "_setAvatar"],
//     ["getInviteeKeys", "_getInviteeKeys"],
//     ["getUserProfileKeys", "_getUserProfileKeys"],
//     ["getGlobalProfileKeys", "_getGlobalProfileKeys"],
//     ["getStatus", "_getStatus"],
//     ["setStatus", "_setStatus"],
//     ["getCreatedAt", "_getCreatedAt"],
//     ["getCreatedBy", "_getCreatedBy"],
//     ["getNameTimestamp", "_getNameTimestamp"],
//     ["ensureInviteeOrWritable", "_ensureInviteeOrWritable"],
// ].forEach(function (arr) {__addPersonAliasFunction.apply(null, arr); });


// //Properties
// [
//     ["name", "_getName"],
//     ["email", "_getEmail"],
//     ["badEmail", "_getBadEmail"],
//     ["firstName", "_getFirstName"],
//     ["lastName", "_getLastName"],
//     ["wasEvicted", "_getWasEvicted"],
//     ["hasLeft", "_getHasLeft"],
//     ["avatar", "_getAvatar"],
//     ["inviteeKeys", "_getInviteeKeys"],
//     ["userProfileKeys", "_getUserProfileKeys"],
//     ["globalProfileKeys", "_getGlobalProfileKeys"],
//     ["status", "_getStatus"],
//     ["lastTimestamp", "_getLastTimestamp"],
//     ["createdAt", "_getCreatedAt"],
//     ["createdBy", "_getCreatedBy"],
//     ["nameTimestamp", "_getNameTimestamp"],
//     ["isHeadOfHousehold", "_getIsHeadOfHousehold"]
// ].forEach(function (arr) {__addPersonAliasProperty.apply(null, arr); });